import React from "react";
import "./App.css";

export default function AdminApp() {
  return <div className="admin-app">AdminApp</div>;
}
